import { BILLPAYMENTHTTPSTATUSCODES } from './wallet-services-type';
import { WALLETCARDRETVAL } from '../models/wallet/wallet-card';
import { REGISTER_RET_VAL, WALLET_ACTIVATION_RETVAL } from '../../providers/myria/app-variables';

export enum AnalyticsResetType {
  UserToUser = 'user_to_user',
  UserToAnonymous = 'user_to_anonymous',
  AnonymousToUser = 'anonymous_to_user',
}

export enum SegmentLocationNames {
  Landing = 'Landing',
  CountryConfirmed = 'Country Confirmed',
  Registration = 'Registration',
  Biometrics = 'Biometrics',
  Activity = 'Activity',
  SendMoney = 'Send Money',
  SendAgain = 'Send Again',
  Settings = 'Settings',
  Login = 'Login',
  Relogin = 'Relogin',
  LiteRegistrationFlow = 'Lite',
  FullRegistrationFlow = 'Full',
  FxOnlineDeeplinkRegistrationFlow = 'FxOnline Deeplink',
  VoicePhoneVerfication = 'Voice',
  SmsPhoneVerification = 'SMS',
  WhatsAppPhoneVerification = 'WhatsApp',
  EmailVerification = 'Email',
  CheckPrices = 'Check Prices',
  Account = 'Account',
  TransferDetails = 'Transfer details',
  ForgotPassword = 'Forgot Password',
  ReviewDetails = 'Review Details',
  Recipients = 'Recipients',
  Resume = 'Resume',
  Profile = 'Profile',
  DeleteWalletPin = 'Delete Wallet Pin',
  Wallet = 'Wallet',
  WalletCard = 'Wallet Card',
  LogBackInModal = 'Login Back in Modal',
  DeepLink = 'DeepLink',
  None = 'None',
  ReferaFriend = 'Refer a Friend',
  HomeScreen = 'Home Screen',
  WalletCheckLimits = 'WalletCheckLimits',
  SendRemittance = 'SendRemittance',
  InwardRemittance = 'Inward Remittance',
  LogIn= 'Log In',
  TrackATransfer = 'Track A Transfer',
  FindALocation = 'Find A Location',
  Singpass = "Singpass",
  FxOnlineDeeplink = "FxOnline Deeplink",
  PendingOrderEkycStartPage = "Pending Order Ekyc Start Page",
  Carousel = "Carousel",
  Home = 'Home'
}

export enum ContactModalReasons {
  StagedBarcodeNotReturned = 'Staged Barcode Not Returned',
  DeleteWalletNotAvailable = 'Delete Wallet Not Available',
  UserCannotEditRecipient = 'User Cannot Edit Recipient',
  UserCannotAddRecipient = 'User Cannot Add Recipient',
  ModifyRecipientNameNotAvailableCustomerOnHold = 'Modify Recipient Name Not Available Customer On Hold',
  ModifyRecipientNameNotAccepted = 'Modify Recipient Name Not Accepted',
  RegistrationDeeplinkInvalid = 'Registration Deeplink Invalid',
  RegistrationAccountBlockedAUUK = 'Registration Account Blocked AU UK',
  RegistrationDeeplinkExpired = 'Registration Deeplink Expired',
  RegistrationDuplicatedUser = 'Registration Duplicated User',
  AccountBlockedIdVerification = 'Account Blocked Id Verification',
  IdVerificationAttempts = 'Id Verification Attempts',
  WalletActivationFailed = 'Wallet Activation Failed',
  RiaCardCVV = 'Ria Card CVV',
  RiaCardDeletionFailed = 'Ria Card Deletion Failed',
  TransactionCancelationNotAvailable = 'Transaction Cancelation Not Available',
  RiaCardNotDelivered = 'Ria Card Not Delivered',
  RiaCardUserProblemReport = 'Ria Card User Problem Report',
  RiaCardBlockedForSecurity = 'Ria Card Blocked For Security',
  RiaWalletPinMismatch = 'Ria Wallet Pin Mismatch',
  RiaCardBlockedByCompliance = 'Ria Card Blocked By Compliance',
  RiaCardPermanentlyBlocked = 'Ria Card Permanently Blocked',
  RegistrationAccountBlocked = 'Registration Account Blocked',
  LiteOrFullRegistrationAccountBlocked = 'Lite Or Full Registration Account Blocked',
  FraudCheckFailed = 'Fraud Check Failed',
  CustomerAccountNotActive = 'Customer Account Not Active',
  WalletInwardRemittanceConversion = 'Wallet Inward Remittance Conversion',
  RiaCardDamaged = 'Ria Card Damaged',
  None = ''
}

export enum AddressSource {
  Loqate = 'loqate',
  Manual = 'manual',
  Singpass = 'singpass',
}

export enum AnalyticsEventType {
  RegistrationStarted = 'Registration Started',
  RegistrationCompleted = 'Account Creation Completed client-side',
  RegistrationFailed = 'Account Creation Failed client-side',
  LoginAccessed = 'Login Accessed',
  ApplicationInstalled = 'Application Installed',
  ApplicationOpened = 'Application Opened',
  ApplicationUpdated = 'Application Updated',
  LoginStarted = 'Login Started',
  BiometricsFailed = 'Biometrics Failed',
  LoginFailed = 'Login Failed client-side',
  BannerDisplayed = 'Banner Displayed',
  BannerCtaClicked = 'Banner CTA Clicked',
  ElementClicked = 'Element Clicked',
  BiometricsSetupCompleted = 'Biometrics Setup Completed',
  BiometricsSetupFailed = 'Biometrics Setup Failed',
  BiometricsUpdateCompleted = 'Biometrics Update Completed',
  BiometricsVerificationSuccesful = "Biometrics Verification Successful",
  LanguageSelected = 'Language Selected',
  PasswordRecoveryStarted = 'Password Recovery Started',
  PasswordRecoveryResetAccessed = 'Password Recovery Reset Accessed',
  PasswordRecoveryNewPassword = 'Password Recovery New Password',
  LoginSuccessful = 'Login Successful client-side',
  BiometricsVerificatioFailed = 'Biometrics Verification Failed',
  ProfileUpdated = 'Profile Updated',
  AddressUpdated = 'Address Updated',
  PasswordCreated = 'Password Created',
  PasswordCreationFailed = 'Password Creation Failed',
  PasswordRecoveryMethod = 'Password Recovery Method Selected',
  PhoneFailed = 'Phone Failed',
  PhoneUpdated = 'Phone Updated',
  OwnershipVerificationStarted = 'Ownership Verification Started',
  OwnershipVerificationCompleted = 'Ownership Verification Completed',
  OwnershipVerificationFailed = 'Ownership Verification Failed',
  OwnershipVerificationCancelled = 'Ownership Verification Canceled',
  OtpChannelSelectorShown = 'OTP Channel Selector Shown',
  OtpChannelSelected = 'OTP Channel Selected',
  OtpChannelSelectorDismissed = 'OTP Channel Selector Dismissed',
  EmailVerificationFailed = 'Email Verification Failed',
  CountryConfirmed = 'Country Confirmed',
  SecurityMethodCompleted = 'Security Method Completed',
  RecipientsAccessed = 'Recipients Accessed',
  QuoteAccessed = 'Quote Accessed',
  TrackTransferAccessed = 'Track Transfer Accessed',
  TransferFound = 'Transfer Found',
  TransferNotFound = 'Transfer Not Found',
  FindALocationAccessed = 'Find A Location Accessed',
  TransferDetailsAccessed = 'Transfer Details Accessed',
  FundingStarted = 'Funding Started',
  TransferDetailsShared = 'Transfer Details Shared',
  IdentityVerificationStarted = 'Identity Verification Started client-side',
  IdentityVerificationCompleted = 'Identity Verification Completed client-side',
  IdentityVerificationPendingViewed = 'Identity Verification Pending Viewed client-side',
  RecipientCreationStarted = 'Recipient Creation Started',
  RecipientSelected = 'Recipient Selected',
  PickUpAgentSelected = 'Pick Up Agent Selected',
  HomeDeliveryAgentSelected = 'Home Delivery Agent Selected',
  PayoutLocationSelected = 'Payout Location Selected',
  DeliveryMethodSelected = 'Delivery Method Selected',
  PayoutPartnerSelected = 'Payout Partner Selected',
  PaymentMethodSelected = 'Payment Method Selected',
  PaymentMethodUpdated = 'Payment Method Updated',
  PaymentMethodDeleted = 'Payment Method Deleted',
  NewPaymentMethodStarted = "New Payment Method Started",
  CvvEntered = 'CVV entered',
  TransactionEdit = 'Transaction Edit',
  TransferSummaryConfirmed = 'Transfer Summary Confirmed',
  AccountValidationResolved = 'Account Validation Resolved',
  TermsAccessed = 'Terms Accessed',
  ESignConsentSelected = 'E-Sign Consent Selected',
  PrivacyAccessed = 'Privacy Accessed',
  AdditionalDetailsAccessed = 'Additional Details Accessed',
  AdditionalDetailsCompleted = 'Additional Details Completed',
  TransferRetry = 'Transfer Retry',
  IDUpdated = 'ID Updated',
  ReceiptViewed = 'Receipt Viewed',
  ActivityScreenAccessed = 'Activity Screen Accessed',
  HomeScreenAccessed = 'Home Screen Accessed',
  QuoteConfirmed = 'Quote Confirmed',
  QuoteCalculated = 'Quote Calculated',
  PromoApplied = 'Promo Applied',
  PromoAccessed = 'Promo Accessed',
  PromoFailed = 'Promo Failed',
  TransactionCreated = 'Transaction Created Entered Order - Client-side',
  TransactionEdited = 'Transfer Edit Completed',
  TransactionFailed = 'Transaction Failed',
  TransactionFeedbackSubmitted = 'Transaction Feedback Submitted',
  InternalIssueReported = 'Internal Issue Reported',
  TransactionVerificationFailed = 'Transaction Validation failed',
  ProfileCreated = 'Profile Created',
  AddressCreated = 'Address Created',
  AccountLinkingFailed = 'Account Linking Failed',
  TransferResendStarted = 'Transfer Resend Started',

  SecurityQuestionsCompleted = 'Security Questions Completed',
  PlaidEvent = 'PlaidEvent',
  BankVerificationComplete = 'Bank Verification Complete',
  BankVerificationFailed = 'Bank Verification Failed',
  ScanCardStarted = 'Scan Card Started',
  ScanCardCompleted = 'Scan Card Completed',
  NetworkError = 'Network Error',
  MFAMigrationStarted = 'MFA Migration Started',
  MFAMigrationComplete = 'MFA Migration Complete',
  MFAMigrationFailed = 'MFA Migration Failed',
  ReferralFailed = 'Referral Failed',
  ReferralCodeSent = 'Referral Created',
  ReferralScreenAccessed = 'Referral Screen Accessed',
  ReferralCodeCreated = 'Referral Created',
  ReferralShared = 'Referral Shared',
  ReferralCodeCopied = 'Referral Code Copied',
  EmailAccessed = 'Email Accessed',
  OtpResendRequested = 'OTP Resend Requested',
  OtpFailed = 'OTP Code Failed',
  OTPHelpSelected = 'OTP Help Selected',
  ModifyOrderStarted = 'Order Modification Started',
  OrderModificationCompleted = 'Recipient Name Modification Completed',
  NewPaymentMethodCompleted = 'New Payment Method Completed', // not used anymore
  RecipientWalletSelected = 'Recipient Wallet Selected',
  PEPQuestionAsked = 'PEP Question Asked',
  PEPQuestionAnswered = 'PEP Question Answered client-side',
  TelemarketingQuestionAnswered = 'Telemarketing Question Answered',
  InAppMessagesAccessed = 'Mobile Inbox Accessed',
  KlarnaStarted = 'Klarna Started',
  KlarnaFailed = 'Klarna Failed',
  HelpSelected = 'Help Selected',
  HelpAccessed = 'Help Accessed',
  InAppReviewCompleted = 'In-app Review Completed',
  WithdrawalStarted = 'Withdrawal Started',
  QRSuccessful = 'QR Successful',
  QRFailed = 'QR Failed',
  WithdrawalFailed = 'Withdrawal Failed client-side',
  WithdrawalCompleted = 'Withdrawal Completed client-side',
  MerchantPaymentStarted = 'Merchant Payment Started',
  MerchantPaymentCompleted = 'Merchant Payment Completed',
  MerchantPaymentFailed = 'Merchant Payment Failed',
  CancelWithdrawalFailed = 'Cancel withdrawal Failed',
  WithdrawalCanceled = 'Withdrawal Canceled',
  WalletAccessed = 'Wallet Accessed',
  WalletScannerAccessed = "Wallet Scanner Accessed",
  WalletP2PQRAccessed = "Wallet P2P QR Accessed",
  WalletLimitsAccessed = "Wallet Limits Accessed",
  WalletActivateStarted = 'Activate Wallet Started',
  WalletCreationStarted = 'Wallet Creation Started',
  PasscodeCreationStarted = 'Passcode Creation Started',
  PasscodeCreationFailed = 'Passcode Creation Failed',
  PasscodeRecoverySuccessful = 'Passcode Recovery Successful',
  PasscodeRecoveryFailed = 'Passcode Recovery Failed',
  PasscodeRecoveryStarted = "Passcode Recovery Started",
  DepositAccessed = 'Wallet Deposit Accessed',
  DirectBankPaymentStarted = 'Direct Bank Payment Started',
  BranchIFSCLookupStarted = 'Branch or IFSC lookup started',
  WalletLocked = 'Wallet Locked',
  HubPageAccessed = 'Hub Accessed',
  TransferSummaryEdited = 'Transfer Summary Edited',
  RateChangedAfterCreationNotified = 'Rate Changed After Creation Notified',
  PasscodeConfirmation = 'Passcode Confirmation',
  PasscodeConfirmed = 'Passcode Confirmed',
  ModifyRecipientNameStarted = 'Recipient Name Modification Started',
  WithdrawalAccessed = 'Withdrawal Accessed',
  WithdrawalAmountFailed = 'Withdrawal Amount Failed',
  WithdrawalRequested = 'Withdrawal Requested',
  WithdrawalAmountConfirmed = 'Withdrawal Amount Confirmed',
  MerchantPaymentAmountFailed = 'Merchant Payment Amount Failed',
  MerchantPaymentAmountConfirmed = 'Merchant Payment Amount Confirmed',
  TransferResendValidated = 'Transfer Resend Validated',
  TransferResendFailed = 'Transfer Resend Failed',
  P2PSendStarted = 'P2P Send Started',
  DocUploadStarted = 'Document Upload Started',
  DocUploadSubmittedFailed = 'Document Upload Submission Failed',
  DocUploadCompleted = 'Document Upload Completed',
  TransactionAmountEdited = "Transaction Amount Edited",
  TransferSummaryUpdated = "Transfer Summary Updated",
  TransferSummaryAccessed = "Transfer Summary Accessed",
  NotificationPreferencesSelected = "Notification Preferences Selected",
  AccountDeletionAccesed = "Account Deletion Accessed",
  PasswordRecoveryAccessed = "Password Recovery Accessed",
  WalletActivationCompleted = "Wallet Activation Completed",
  IdentifyWalletActivationCompleted = "Identify - Wallet Activation Completed",
  IdentifyRegistrationPhone = "Identify - Registration Phone",
  IdentifyRegistrationEmail = "Identify - Registration Email",
  IdentifyRegistrationFlowCompleted = "Identify - Registration Flow Completed",
  WalletBalanceLoaded = "Wallet Balance Loaded",
  WalletTransactionsLoaded = "Wallet Transactions Loaded",
  AccountDeletionRequestSubmitted = "Account Deletion Request Submitted",
  ReferralCodeEntered = 'Referral Code Entered',
  MissingInformationStarted = 'Missing Information Started',
  P2PInviteSent = 'P2P Invite Sent',
  PToPContactSelected = 'P2P Contact Selected',
  PToPSendAmountConfirmed = 'P2P Send Amount Confirmed',
  SecurityMethodStarted = 'Security Method Started',
  SecurityMethodFailed = 'Security Method Failed',
  SecurityMethodCancelled = 'Security Method Canceled',
  FintocWidgetCompleted = 'Fintoc Widget Completed',
  FintocWidgetAccessed = 'Fintoc Widget Accessed',
  DriverLicenseSelected = 'Driver License Tooltip Selected',
  CompleteLoginCreation = 'Login Creation Completed client-side',
  P2PSendSuccessfulClientSide = 'P2P Send Successful client-side',
  P2PSendFailedClientSide = 'P2P Send Failed client-side',
  PasscodeSubmitted = "Passcode Submitted",
  PasscodeFailed = "Passcode Failed",
  RecipientBankDetailsSaveFailed = 'Bank Deposit Data Saving Failed',
  CaptchaChallengeStarted = 'Captcha Challenge Started',
  CaptchaChallengeFinished = 'Captcha Challenge Finished',
  CaptchaChallengeFailed = 'Captcha Challenge Failed',
  CountryConfirmationFailed = 'Country Confirmation Failed',
  ImpactUserStarted = 'Impact User Started client-side',
  AffiliateStarted = 'Affiliate Started client-side',
  WithdrawalBankAccountVerificationConfirmed = 'Withdrawal Bank Account Verification Confirmed',
  WithdrawalAccountVerificationFailed = 'Withdrawal Account Verification Failed',
  PasswordUpdateAccessed = 'Password Update Accessed',
  PasswordUpdateCompleted = 'Password Update Completed',
  PendingTransferResumed = 'Pending Transfer Resumed',
  NonWalletRecipientPromptDisplayed = 'Non-Wallet Recipient Prompt Displayed',
  NonWalletRecipientPromptActioned = 'Non-Wallet Recipient Prompt Actioned',
  PendingTransferCancelled = 'Pending Transfer Cancelled',
  VisaSubmissionRequested = "Visa Submission Requested",
  WalletCardDeliveryAddressModified = "Card Delivery Address Modified",
  WalletCardLocationsOpened = "Card Locations Opened",
  WalletCardReceiveMethodSelected = "Card Receive Method Selected",
  WalletCardRequestStarted = "Card Request Started",
  WalletCardRequestFailed = "Card Request Failed",
  WalletCardActivationStarted = "Card Activation Started",
  WalletPhysicalCardReplacementStarted = "Card Replacement Started",
  WalletPhysicalCardPINCreationStarted = "Card PIN Creation Started",
  WalletPhysicalCardPINEntered = "Card PIN Entered",
  WalletPhysicalCardPINConfirmed = "Card PIN Confirmed",
  WalletCardActivationSuccessful = "Card Activation Successful client-side",
  WalletCardPINCreationFailed = "Card PIN Creation Failed client-side",
  WalletphysicalCardCreationSuccessful = "Card PIN Creation Successful client-side",
  WalletphysicalCardCreationFailed = "Card Activation Failed",
  CardManagementAccessed = "Card Management Accessed",
  CardDetailsAccessed = "Card Details Accessed",
  CardLocked = "Card Locked",
  CardUnlocked = "Card Unlocked",
  CardAllowedPaymentsUpdated = "Card Allowed Payments Updated",
  CardReplacementStarted = "Card Replacement Started",
  AddressValidationStarted = "Address Validation Started",
  AddressValidationCompleted = "Address Validation Completed",
  CardDetailsFailed = "Card Details Failed",
  ContactModalDisplayed = "Contact Care Modal Displayed",
  ContactButtonClicked = "Contact Care CTA Clicked",
  ProductReviewStarted = "Product Review Started",
  ConsentOptionSelected = "Consent Option Selected",
  ERSwitchScreenAccessed = "ER Switch Screen Accessed",
  ERSwitchScreenCompleted = "ER Switch Screen Completed",
  IdentityVerificationRequired = "Identity Verification Required",
  AirtimeAccessed = "Airtime Accessed",
  AirtimeRecipientEntered = "Airtime Recipient Entered",
  AirtimeRecipientFailed = "Airtime Recipient Failed",
  AirtimeSummaryConfirmed = "Airtime Summary Confirmed",
  AirtimeFailed = "Airtime Failed",
  PartnerCheckoutOpened = "Partner Checkout Opened",
  PartnerCheckoutCompleted = "Partner Checkout Completed",
  PasscodeChallengeStarted = "Passcode Challenge Started",
  PasscodeChallengeSuccessful = "Passcode Challenge Successful",
  PasscodeChallengeFailed = "Passcode Challenge Failed",
  CreateProfileStarted = "Create Profile Started",
  ScreenLockPrompted = "Screen Lock Prompted",
  ManualAddressTapped = "Manual Address Tapped",
  CVVRequested = "CVV Requested",
  PaymentChangeAccessed = "Payment Change Accessed",
  PaymentMethodChanged = "Payment Method Changed",
  RecipientBankDetailsAdded = "Recipient Bank Details Added",
  AddFromContactsStarted= "Add From Contacts Started",
  WalletUpgradeRequested = "Wallet Upgrade Requested by eKyc",
  BillPayAccessed = "Bill Pay Accessed",
  BillPayAccountEntered = "Bill Pay Account Entered",
  BillPayAccountFailed = "Bill Pay Account Failed",
  BillPaySummaryConfirmed = "Bill Pay Summary Confirmed",
  BeneficialOwnerQuestionAsked = "Beneficial Owner Question Asked",
  BeneficialOwnerQuestionAnswered = "Beneficial Owner Question Answered",
  PasscodeUpdateAccessed = "Passcode Update Accessed",
  PasscodeUpdateSuccessful = "Passcode Update Successful",
  PasscodeUpdateFailed = "Passcode Update Failed",
  BiometricsVerificationCompleted = "Biometrics Verification Completed",
  MerchantAssistanceAccessed = "Merchant Assistance Accessed",
  CarrouselCardClicked = "Carrousel Card Clicked",
  InwardRemittanceStarted = "Inward Remittance Started",
  CarouselCardClicked = "Carousel Card Clicked",
  CarouselCTAClicked = "Carousel CTA Clicked",
  QRScannerAccessed = "Wallet P2P Scanner Accessed",
  QRAccessed = "Wallet P2P QR Accessed",
  WalletP2PQRReceiveAccessed = "Wallet P2P QR Receive Accessed",
  WalletP2PQRReceiveAmountSelected = "Wallet P2P QR Receive Amount Selected",
  WalletP2PQRReceiveShared = "Wallet P2P QR Receive Shared",
  PayoutAgentSelected = "Payout Agent Selected",
  BillingAddressUpdated = "Billing Address Updated",
  RecipientCreationInteraction = 'Recipient Creation Interaction',
  PaymentAccessed = "Payment Accessed",
  PasswordRecoveryQuestionStarted = "Password Recovery Question Started",
  PasswordRecoveryQuestionCompleted = "Password Recovery Question Completed",
  PasswordRecoveryQuestionBlocked = 'Password Recovery Question Blocked',
  LoginQuestionStarted = 'Login Question Started',
  LoginQuestionCompleted = 'Login Question Completed',
  LoginQuestionBlocked = 'Login Question Blocked',
  UserPropertiesReset = "User Properties Reset",
  UserIDTypeSelected= "ID Type Selected",
  BankValidationChecked = "Bank Validation Checked",
  EditRecipientAccessed = "Edit Recipient Accessed",
  EditRecipientSaved = "Edit Recipient Saved",
  AgentReferralScreenAccessed = "Agent Referral Screen Accessed",
  SendToMyselfInteraction = "Send To Myself Interaction",
  KnowledgeQuestionAnswered = "Knowledge Question Answered",
  AccountLinkingCompletedclientside = "Account Linking Completed client-side",
  SubmitAppealClicked = "Submit Appeal Clicked",
  AccountLinkingFailedClientSide = "Account Linking Failed client-side",
  WalletDepositStarted = 'Wallet Deposit Started',
  DepositReceiptUploadStarted = 'Deposit Receipt Upload Started',
  ReportsAndStatementsAccessed = 'Reports and Statements Accessed',
  TransferCertificateRequested = 'Transfer Certificate Requested',
  TransferEditStarted = "Transfer Edit Started",
  TransferEditCanceled = "Transfer Edit Canceled",
  HiddenMenuOpened = 'Hidden Menu Opened',
  HiddenMenuFeatureActivated = 'Hidden Menu Feature Activated',
  HiddenMenuFeatureDeactivated = 'Hidden Menu Feature Deactivated',
  ForceUpdateRequested = 'Force Update Requested',
  ForceUpdateCTAClicked = 'Force Update CTA Clicked',
  TransactionRejectedByCompliance = 'Transaction Rejected By Compliance',
  GeolocationPrompted = 'Geolocation Prompted',
  GeolocationCompleted = 'Geolocation Completed',
  DuplicateTransferModalViewed = 'Duplicate Transfer Modal Viewed',
  DuplicateTransferModalConfirmed = 'Duplicate Transfer Modal Confirmed',
  DuplicateTransferModalCancelled = 'Duplicate Transfer Modal Cancelled',
  FeatureFlagsResolved = 'Feature Flags Resolved',
  NpsSurveyShown = 'NPS Survey Shown',
  NpsSurveyScored = 'NPS Survey Scored',
  NpsSurveyCompleted = 'NPS Survey Completed',
  NpsSurveyDismissed = 'NPS Survey Dismissed',
  LegacyAccountRelinkViewed = 'Legacy Account Relink Viewed',
  LegacyAccountRelinkPrompted = 'Legacy Account Relink Prompted',
  LegacyAccountRelinkCompleted = 'Legacy Account Relink Completed',
  PhoneVerificationFailed = 'Phone Verification Failed'
}

export enum ForeignIpIssueName {
  SanctionedCountry = 'Sanctioned Country',
  NineMonthRestriction = '9-Month Restriction',
  MockGps = 'Mock GPS',
}

export enum ContactType {
  Call = "Call",
  Chat = "Chat",
  Email = "Email",
  HelpCenter = "Help Center",
}

export enum HelpMethod {
  Call = "Call",
  Chat = "Chat",
  FAQ = "FAQ"
}
export enum OTPType {
  Email = "email",
  SMS = "sms",
  Call = "call",
}

export const AccountValidationType = {
  SepaVop: 'SEPA_VOP',
};

export const AccountValidationDecision = {
  AutoContinue: 'AUTO_CONTINUE',
  UseRegisteredName: 'USE_REGISTERED_NAME',
  KeepEnteredName: 'KEEP_ENTERED_NAME',
  ContinueWithoutMatch: 'CONTINUE_WITHOUT_MATCH',
  EditName: 'EDIT_NAME',
  ContinueAnyway: 'CONTINUE_ANYWAY',
  ChangeDeliveryMethod: 'CHANGE_DELIVERY_METHOD',
};

export const HttpStatusDescriptions: { [key: number]: string } = {
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Content",
  423: "Locked",
  424: "Failed Dependency",
  425: "Too Early",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  451: "Unavailable For Legal Reasons",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  510: "Not Extended",
  511: "Network Authentication Required",
};

export enum AnalyticsPaymentMethodData {
  /**
   * @deprecated Use the option CreditCard for event tracking
   */
  Credit = "Credit",
  /**
   * @deprecated Use the option DebitCard for event tracking
   */
  Debit = "Debit",
  DirectBank = "Direct Bank",
  Staged = "Staged",
  BankAccount = "Bank Account",
  Wallet = "Wallet",
  RiaLocation = "Ria Location",
  StagedOnline = "Staged Online",
  CreditCard = "Credit Card",
  DebitCard = "Debit Card",
  ApplePay="Apple Pay",
  GooglePay="Google Pay",
  OpenBanking="Open Banking",
}

export interface AnalyticsPhoneVerification {
  location: string;
  phoneNumber: string;
  phoneCountry?: string;
}

export interface AnalyticsPhoneEventsVerification {
  location: string;
  phoneNumber: string;
  phoneCountry?: string;
  email: string;
  registrationFlowType?: string;
}

export enum StagedVendorType {
  StagedRia = "Staged Ria",
  PayNearMe = "PayNearMe",
  Sencillito = "Sencillito",
  StagedOnline = "Staged Online"
}

export enum OpenBankingBrand {
  TrueLayer = 'TrueLayer',
}

export enum DirectBankVendorType {
  Sofort = "Sofort",
  FPX = "FPX",
  Poli = "Poli",
  Fintoc = "Fintoc",
  GiroPay = "Giropay",
  PayID = "PayID",
  Klarna = 'Klarna',
  IDeal = 'IDeal',
  Bancontact = 'Bancontact',
  StagedOnline = "PayNow",
  Blik = 'Blik',
  MBWay = 'MbWay',
  Swish = 'Swish'
}

export enum PayoutAgentType {
  Open = "Open Network",
  Specific = "Point-to-point",
  OpenPaymentCountry = "Open Payment Country",
  PreferredNetwork = "Preferred Network",
  Bank = "Bank",
  VPA = "VPA",
  Wallet = "Wallet",
  OfficePickup = "Cash Pickup"
}
 
export enum AnalyticsPayoutMethodType {
  OfficePickup = "Cash Pickup",
  BankAccount = "Bank Account",
  HomeDelivery = "Home Delivery",
  RiaWallet = "Ria Wallet",
}

export enum AnalyticsCardLostReasonsType {
  Lost = "I lost my card",
  Stolen = "My card was stolen",
  Damaged = "My card was damaged",
  Expired = "Card is expired",
  NotArrived = "My card hasn't arrived"
}

export enum AnalyticsWalletCard {
  cardActivation = "Ria Card Activation",
  cardPinChange = "Ria Card PIN Change",
  physicalCardApplyFailed = "Wallet physical card request failed",
  virtucalCardApplyFailed = "Wallet virtucal card request failed",
  cvvActivationFailed = "CVV card activation failed",
  cardPINSetUpFailed = "Card PIN Creation failed",
  cardPINSetUpfailedMsg = "Couldn't set PIN for physical card",
  cardReqDeepLink = "Deep",
  cardReqHome = "Home",
  FailedToFetchFromAPI = "Failed to fetch details from API",
  FailedToEnableBioMetrics = "Failed to enable bio metrics",
  CardRequestSuccess="Card Request Successful client-side"
}

export enum AnalyticsCardPinFailureReason {
  InvalidPinFormat = "Invalid PIN Format",
  PinAlreadySet = "PIN Already Set",
  RateLimitExceeded = "Rate Limit Exceeded",
  CardLocked = "Card Locked",
  ClientTimeout = "Client Timeout",
  InvalidTransactionPin = "Invalid Transaction PIN",
  WalletLocked = "Wallet Locked",
  PinSameAsPrevious = "PIN Same As Previous",
  PinRepeatingDigits = "PIN Repeating Digits",
  CardNotFound = "Card Not Found",
  CardNotActive = "Card Not Active",
  ProviderError = "Provider Error",
  ProviderUnavailable = "Provider Unavailable",
  PinConfirmationMissing = "PIN Confirmation Missing",
  ResponseMissing = "Response Missing",
  Unknown = "Unknown"
}

export const CARD_PIN_FAILURE_REASON_BY_CODE: { [code: number]: AnalyticsCardPinFailureReason | undefined } = {
  [REGISTER_RET_VAL.CUSTOMER_PIN_INVALID_CONTAIN]: AnalyticsCardPinFailureReason.PinRepeatingDigits,
  [WALLETCARDRETVAL.WALLET_LOCKED]: AnalyticsCardPinFailureReason.WalletLocked,
  [BILLPAYMENTHTTPSTATUSCODES.WRONG_PIN_ATTEMPTS]: AnalyticsCardPinFailureReason.InvalidTransactionPin,
  [WALLETCARDRETVAL.CARD_LOCKED]: AnalyticsCardPinFailureReason.CardLocked,
  [WALLETCARDRETVAL.INVALID_PIN]: AnalyticsCardPinFailureReason.InvalidPinFormat,
  [WALLETCARDRETVAL.PIN_SAME_AS_PREVIOUS]: AnalyticsCardPinFailureReason.PinSameAsPrevious,
  [WALLETCARDRETVAL.CARD_PINATTEMPTS_EXCEEDED]: AnalyticsCardPinFailureReason.RateLimitExceeded,
  [WALLET_ACTIVATION_RETVAL.NO_RECORD_FOUND]: AnalyticsCardPinFailureReason.CardNotFound,
  [WALLET_ACTIVATION_RETVAL.GENERIC_ERROR]: AnalyticsCardPinFailureReason.ProviderError,
  [WALLET_ACTIVATION_RETVAL.PROVIDER_COMMUNICATION_ERROR]: AnalyticsCardPinFailureReason.ProviderUnavailable,
  [WALLET_ACTIVATION_RETVAL.UNKOWN_ERROR]: AnalyticsCardPinFailureReason.ProviderError,
  [WALLETCARDRETVAL.ACCOUNT_EXISTS]: AnalyticsCardPinFailureReason.PinAlreadySet,
  [WALLETCARDRETVAL.INVALID_DATA_LENGTH]: AnalyticsCardPinFailureReason.InvalidPinFormat,
  [WALLETCARDRETVAL.CARD_NOT_ACTIVE]: AnalyticsCardPinFailureReason.CardNotActive,
  [WALLETCARDRETVAL.SYSTEM_ERROR]: AnalyticsCardPinFailureReason.ProviderError
};

export enum AnalyticsAirtimeFailureReason {
  PrepaidProductNotFound = "Prepaid Product Not Found",
  NetworkError = "Network Error",
  Unknown = "Unknown"
}

export enum NotificationSelectionType {
  subscribed = 'Subscribed',
  notSubscribed = 'Not Subscribed'
}

export enum ESignConsentOptionType {
  agreed = 'agreed',
  blocked = 'blocked'
}

export enum LegalDocumentType {
  terms = 'terms',
  privacy = 'privacy',
  esign = 'esign'
}

export enum AnalyticsBankVerificationMethod {
  Instant = "Instant Auth",
  AutomatedMicroDeposits = "Automated Micro-deposits",
  SameDayMicroDeposits = "Same Day Micro-deposits",
}

export enum MobileInboxAccessLocations {
  ProfileAndSettings = "Profile And Settings",
  HomeScreenCarousel = "Home Screen Carousel",
}

export enum AnalyticsProfileCreationStartedLocations {
  Notification = "Notification",
  Settings = "Settings",
  Account = "Account",
  Recipients = "Recipients",
  SendMoney = "Send Money",
}

export enum ScreenLockSelection {
  TurnOn = "Turn On",
  DontUse = "Don't Use",
}

export enum TransferEditedRateError {
  RateVariation = "Rate Variation"
}

export enum UserLoggingStatus {
  LoggedIn = "Logged In",
  LoggedOut = "Logged Out",
}
export enum AnalyticsWallet {
  InApp = "In-App",
  QRScan = "Ria QR Scan",
  P2PSend = "P2P Send",
  DuitNowQRScan = "DuitNow QR Scan"
}

export enum PasscodeChallengeLocation {
  Merchant = "Merchant",
  Withdrawal = "Withdrawal",
  P2PSend = "P2P Send",
  SendMoney = "Send Money",
  Airtime = "Airtime",
  BillPay = "Bill Pay",
  LogIn = "Log In",
  UpdatePasscode = "Update Passcode"
}

export enum RoutedRail {
  DuitNow = "DuitNow",
  ClosedLoop = "Closed-Loop"
}

export enum CarouselCardType {
  Alert = "Alert",
  Iterable = "Iterable",
  Kyc = 'kyc',
  CrossSell = 'cross_sell',
}

export enum CarouselCTAEntryPoint {
  Carousel = 'Carousel',
  Inbox = 'Inbox',
}

// Separate from Carousel Card Clicked so the card tap keeps its own history.
export interface ICarouselCTAClicked {
  cardType: CarouselCardType;
  url: string;
  campaignId?: string | number; // Iterable sends a number.
  lineNumber?: number;
  messageId?: string;
  entryPoint?: CarouselCTAEntryPoint;
}

export enum AnalyticsPaymentProcessor {
  Adyen = "Adyen", 
  WorldPay = "WorldPay"
}

export enum TransferEditCanceledType {
  UserCancelled = 'user canceled',
  Timeout = 'timeout',
  TechnicalError = 'technical error'
}

export enum DepositMethods {
  JomPay = 'JomPay',
  CashDepositMachine = 'Cash Deposit Machine',
  RiaLocation = 'Ria Location'
}

export enum PendingWalletType {
  liteWallet = 'Lite KYC Account',
  noWallet = 'No Account'
}

export enum NonWalletRecipientPromptAction {
  Proceed = 'Proceed',
  Cancel = 'Cancel'
}

export enum LegacyAccountRelinkEntryPoint {
  PaymentMethods = 'paymentMethods'
}

export enum LegacyAccountRelinkOutcome {
  Linked = 'linked',
  Failed = 'failed',
  Exited = 'exited',
  Dismissed = 'dismissed'
}

export enum PendingTransferCancellationSource {
  Activity = 'Activity'
}

export enum AnalyticsWithdrawalAccountVerificationFailureReason {
  AccountNotFound = 'Account Not Found',
  BankApiUnavailable = 'Bank API Unavailable',
  Unknown = 'Unknown'
}

export enum AnalyticsWithdrawalVerificationMethod {
  BankApi = 'Bank API'
}

export enum BannerType {
  IDExpiringSoon = 'ID Expiring Soon',
  MobileTopUp = 'Mobile Top-Up'
}

export enum OtpFailureReason {
  WrongCode = 'wrong-code',
  MaxAttempts = 'max-attempts',
  AccountLocked = 'account-locked',
  MaxResendAttempts = 'max-resend-attempts',
  UnknownError = 'unknown-error'
}

export enum PasswordRecoveryKnowledgeQuestion {
  DateOfBirth = 'Date of birth'
}

export enum PasswordRecoveryQuestionResult {
  Success = 'Success',
  Failure = 'Failure'
}

export enum PasswordRecoveryQuestionFailureReason {
  IncorrectAnswer = 'incorrect_answer',
  NoValueOnFile = 'no_value_on_file',
  SessionExpired = 'session_expired',
  AttemptLimit = 'attempt_limit',
  Error = 'error'
}



// WEBPACK FOOTER //
// ./src/model/types/analytics.const.ts